import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Navbar.css";

// Logo image
import royalLogo from "./IMGS/ROYALHERITAGEFIESTA.jpeg";

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setMenuOpen(false);
  };

  const handleNavigation = (path, sectionId) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    } else {
      scrollToSection(sectionId);
    }
    setMenuOpen(false);
  };

  const handleLogoClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    setMenuOpen(false);
  };

  const handleServicesClick = (e) => {
    e.preventDefault();
    const modal = document.getElementById("servicesModal");
    if (modal) {
      const bsModal = new window.bootstrap.Modal(modal);
      bsModal.show();
    }
    setMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && menuOpen) {
        setMenuOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [menuOpen]);

  const phoneNumber = "+919966252374";
  const emailAddress = "royaleheritagefiesta@gmail.com";

  return (
    <>
      {/* Desktop Top Header - Hidden on Mobile */}
      <div className="top-header desktop-only">
        <div className="header-left">
          <a href={`tel:${phoneNumber}`} className="header-phone">
            <i className="bi bi-telephone-fill"></i>
            <span>+91 99662 52374</span>
          </a>
        </div>
        <div className="main-heading">ROYAL HERITAGE FIESTA</div>
        <div className="header-right">
          <a href={`mailto:${emailAddress}`} className="header-email">
            <i className="bi bi-envelope-fill"></i>
            <span>royaleheritagefiesta@gmail.com</span>
          </a>
        </div>
      </div>

      {/* Mobile Top Header */}
      <div className="mobile-top-header mobile-only">
        <div className="mobile-header-row">
          <button
            className="mobile-navbar-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle navigation"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <div className="mobile-email-wrapper">
            <a href={`mailto:${emailAddress}`} className="mobile-email">
              <i className="bi bi-envelope-fill"></i>
              <span>royaleheritagefiesta@gmail.com</span>
            </a>
          </div>

          <div className="mobile-placeholder"></div>
        </div>

        <div className="mobile-phone-center">
          <a href={`tel:${phoneNumber}`} className="mobile-phone-link">
            <i className="bi bi-telephone-fill"></i>
            <span>+91 99662 52374</span>
          </a>
        </div>
      </div>

      {/* Navbar */}
      <div className="navbar-container">
        <div className={`custom-navbar ${scrolled ? "scrolled" : ""}`}>
          <div className="mobile-logo-left mobile-only">
            <img
              src={royalLogo}
              alt="Royal Heritage Fiesta"
              className="mobile-logo"
              onClick={handleLogoClick}
            />
          </div>

          <div className="mobile-navbar-heading mobile-only">
            ROYAL HERITAGE FIESTA
          </div>

          <div className={`nav-links ${menuOpen ? "active" : ""}`}>
            <Link
              to="/eventcalander_2"
              onClick={() => setMenuOpen(false)}
              className={location.pathname === '/eventcalander_2' ? 'active' : ''}
            >
              UPCOMING EVENTS
            </Link>

            <Link
              to="/Services"
              onClick={() => setMenuOpen(false)}
              className={location.pathname === '/Services' ? 'active' : ''}
            >
              SERVICES
            </Link>

            <div className="nav-logo-center desktop-only">
              <img
                src={royalLogo}
                alt="Royal Heritage Festia"
                onClick={handleLogoClick}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "https://placehold.co/200x200?text=R";
                }}
              />
            </div>

            <Link
              to="/ContactUs"
              onClick={() => setMenuOpen(false)}
              className={location.pathname === '/ContactUs' ? 'active' : ''}
            >
              CONTACT
            </Link>

            <Link
              to="/aboutUs"
              onClick={() => setMenuOpen(false)}
              className={location.pathname === '/aboutUs' ? 'active' : ''}
            >
              ABOUT US
            </Link>
          </div>
        </div>
      </div>

      {/* Services Modal */}
      <div className="modal fade" id="servicesModal" tabIndex="-1" aria-labelledby="servicesModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content p-3">
            <div className="modal-header border-0 pb-0">
              <h4 className="modal-title" id="servicesModalLabel">Our Signature Services</h4>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-4 mb-3">
                  <div className="card text-center p-3 h-100">
                    <i className="bi bi-crown fs-1"></i>
                    <h6 className="mt-2">Royal Heritage Festia</h6>
                    <small>Curated heritage experiences</small>
                    <Link
                      to="/bookingservices"
                      className="btn-dark-custom btn-sm mt-2"
                      onClick={() => {
                        const modal = document.getElementById("servicesModal");
                        if (modal) {
                          const bsModal = window.bootstrap.Modal.getInstance(modal);
                          bsModal?.hide();
                        }
                      }}
                    >
                      Book Now
                    </Link>
                  </div>
                </div>
                <div className="col-md-4 mb-3">
                  <div className="card text-center p-3 h-100">
                    <i className="bi bi-cup-straw fs-1"></i>
                    <h6 className="mt-2">Royal Dinners</h6>
                    <small>Exquisite dining experiences</small>
                    <Link
                      to="/bookingservices"
                      className="btn-dark-custom btn-sm mt-2"
                      onClick={() => {
                        const modal = document.getElementById("servicesModal");
                        if (modal) {
                          const bsModal = window.bootstrap.Modal.getInstance(modal);
                          bsModal?.hide();
                        }
                      }}
                    >
                      Book Now
                    </Link>
                  </div>
                </div>
                <div className="col-md-4 mb-3">
                  <div className="card text-center p-3 h-100">
                    <i className="bi bi-music-note-beamed fs-1"></i>
                    <h6 className="mt-2">Music & Concerts</h6>
                    <small>World-class performances</small>
                    <Link
                      to="/bookingservices"
                      className="btn-dark-custom btn-sm mt-2"
                      onClick={() => {
                        const modal = document.getElementById("servicesModal");
                        if (modal) {
                          const bsModal = window.bootstrap.Modal.getInstance(modal);
                          bsModal?.hide();
                        }
                      }}
                    >
                      Book Now
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`

        /* ========== DESKTOP STYLES ========== */
        .top-header {
          background: #000;
          padding: 8px 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          z-index: 101;
          margin-left: 5px;
        }

        @media (min-width: 769px) {
          .top-header .main-heading {
            transform: translateX(55px);
          }
        }

        .header-left {
          flex-shrink: 0;
          width: 200px;
        }

        .header-phone {
          color: #fff;
          text-decoration: none;
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 15px;
          transition: all 0.3s ease;
        }

        .header-phone i {
          font-size: 14px;
          color: #25d366;
        }

        .header-phone:hover {
          color: #25d366;
        }

        .header-right {
          flex-shrink: 0;
          width: 280px;
          text-align: right;
        }

        .header-email {
          color: #fff;
          text-decoration: none;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 8px;
          font-size: 12px;
          transition: all 0.3s ease;
        }

        .header-email i {
          font-size: 14px;
          color: #b8860b;
        }

        .header-email:hover {
          color: #b8860b;
        }

        .top-header .main-heading {
          font-family: 'Cinzel', serif;
          font-size: 1.5rem;
          font-weight: 700;
          letter-spacing: 1px;
          text-align: center;
          flex: 1;
          margin: 0;
          color: #fff;
        }

        .navbar-container {
          background: #000;
          padding: 0;
          margin: 0;
          width: 100%;
          border-left: 17px solid #000 !important;
          border-right: 17px solid #000 !important;
          box-sizing: border-box;
        }

        .custom-navbar {
          text-align: center;
          margin: 0 auto;
          padding: 4px 0;
          position: relative;
          background: #f5f5f5;
          transition: all 0.3s ease;
          z-index: 100;
          max-width: 98%;
          width: 98%;
          margin-bottom: 0 !important;
        }

        .nav-logo-center img {
          width: 85px;
          height: 85px;
          border: none;
          box-shadow: none;
          border-radius: 50%;
          object-fit: cover;
          cursor: pointer;
        }

        .nav-links {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 30px;
          flex-wrap: wrap;
        }

        .custom-navbar a {
          margin: 0;
          text-decoration: none;
          color: #333;
          font-weight: 500;
          font-size: 13px;
          letter-spacing: 0.5px;
          transition: 0.3s;
          cursor: pointer;
          background: transparent;
          border: none;
          position: relative;
          padding: 6px 0;
        }

        .custom-navbar a:hover {
          color: #b8860b;
          transform: translateY(-1px);
        }

        .custom-navbar a.active {
          color: #b8860b;
          font-weight: 600;
        }

        .custom-navbar a.active::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 50%;
          transform: translateX(-50%);
          width: 25px;
          height: 2px;
          background: #b8860b;
          border-radius: 2px;
        }

        .navbar-toggle {
          display: none;
        }

        .mobile-navbar-heading {
          display: none;
        }

        .mobile-logo-left {
          display: none;
        }

        .mobile-top-header {
          display: none;
        }

        /* ========== MOBILE STYLES ========== */
        @media (max-width: 768px) {
          .desktop-only {
            display: none !important;
          }

          .mobile-only {
            display: block;
          }

          .mobile-top-header {
            background: #000;
            padding: 12px 15px;
            display: flex;
            flex-direction: column;
            gap: 12px;
           
            border-bottom: 1px solid rgba(255,255,255,0.1);
          }

          .mobile-header-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            gap: 10px;
          }

          .mobile-navbar-toggle {
            display: flex;
            flex-direction: column;
            background: white;
            border: none;
            padding: 4px 7px;
            cursor: pointer;
            border-radius: 6px;
            transition: all 0.3s ease;
            gap: 3px;
            flex-shrink: 0;
          }

          .mobile-navbar-toggle span {
            display: block;
            width: 20px;
            height: 2px;
            background: #000;
            transition: 0.3s;
            border-radius: 2px;
          }

          .mobile-navbar-toggle:hover {
            background: #b8860b;
          }

          .mobile-navbar-toggle:hover span {
            background: white;
          }

          .mobile-email-wrapper {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .mobile-email {
            color: #fbfaf9;
            text-decoration: none;
            display: inline-flex;
            align-items: center;
            gap: 6px;
            font-size: 17px;
            background: rgba(184,134,11,0.1);
            padding: 6px 12px;
            border-radius: 20px;
            transition: all 0.3s ease;
          }

          .mobile-email i {
            font-size: 14px;
          }

          .mobile-email span {
            font-size: 10px;
            word-break: break-all;
          }

          .mobile-placeholder {
            width: 32px;
            flex-shrink: 0;
          }

          .mobile-phone-center {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
          }

          .mobile-phone-link {
            color: #e5eae7;
            text-decoration: none;
            display: inline-flex;
            align-items: center;
            gap: 8px;
            font-size: 12px;
            font-weight: 600;
            background: rgba(37,211,102,0.1);
            padding: 6px 20px;
            border-radius: 25px;
            transition: all 0.3s ease;
          }

          .mobile-phone-link i {
            font-size: 14px;
          }

          .mobile-phone-link span {
            font-size: 12px;
          }

          /*
            KEY FIX:
            - borders restored on container (13.5px each side)
            - custom-navbar is 100% width so it fills the space between borders completely
            - no margin, no gap = no white line anywhere
          */
          .navbar-container {
            background: #000;
            padding: 0;
            margin: 0;
            width: 100%;
            border-left: 17.5px solid #000 !important;
            border-right: 17.5px solid #000 !important;
            box-sizing: border-box;
          }

          .custom-navbar {
            width: 100%;
            max-width: 100%;
            margin: 0 !important;
            padding: 8px 0;
            min-height: 62px;
            position: relative;
            background: #f5f5f5;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
          }

          .mobile-logo-left {
            display: block;
            position: absolute;
            left: 1px;
            top: 50%;
            transform: translateY(-50%);
            z-index: 100;
          }

          .mobile-logo {
            width: 60px !important;
            height: 57px !important;
            border-radius: 50%;
            object-fit: cover;
            cursor: pointer;
            border: none;
            outline: none;
            display: block;
            transition: 0.3s;
          }

          .mobile-logo:hover {
            transform: scale(1.05);
          }

          .mobile-navbar-heading {
            display: block;
            font-family: 'Cinzel', serif;
            font-size: 15px !important;
            font-weight: 700;
            letter-spacing: 1px;
            color: #000;
            text-align: center;
            margin: 0 0 0 25px;
          }

          .nav-links {
            display: none;
            flex-direction: column;
            width: 100%;
            background: #fff;
            padding: 20px;
            position: absolute;
            top: 100%;
            left: 0;
            z-index: 1000;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
            gap: 12px;
            border-radius: 0 0 12px 12px;
          }

          .nav-links.active {
            display: flex;
          }

          .custom-navbar a {
            font-size: 14px;
            margin: 5px 0;
            padding: 10px 15px;
            width: 100%;
            text-align: center;
            border-radius: 8px;
          }

          .custom-navbar a:hover {
            background: rgba(184,134,11,0.05);
          }

          .custom-navbar a.active {
            background: rgba(184,134,11,0.1);
            color: #b8860b;
          }

          .custom-navbar a.active::after {
            display: none;
          }

          .nav-logo-center {
            display: none;
          }
        }

        @media (max-width: 480px) {
          .mobile-logo {
            width: 40px;
            height: 40px;
          }

          .custom-navbar {
            min-height: 56px;
          }

          .mobile-email span {
            font-size: 8px;
          }

          .mobile-email {
            padding: 4px 8px;
          }

          .mobile-phone-link {
            padding: 5px 14px;
          }

          .mobile-phone-link span {
            font-size: 11px;
          }

          .mobile-navbar-heading {
            font-size: 11px;
          }

          .mobile-navbar-toggle {
            padding: 3px 5px;
            gap: 3px;
          }

          .mobile-navbar-toggle span {
            width: 18px;
          }

          .mobile-placeholder {
            width: 28px;
          }
        }

        /* Button styles */
        .btn-dark-custom {
          background: #000;
          color: #fff;
          padding: 8px 20px;
          border-radius: 30px;
          font-size: 12px;
          font-weight: 500;
          border: none;
          transition: 0.3s;
          cursor: pointer;
          text-decoration: none;
          display: inline-block;
        }

        .btn-dark-custom:hover {
          background: #b8860b;
          color: #fff;
          transform: translateY(-2px);
        }

        .custom-navbar.scrolled {
          background: rgba(245, 245, 245, 0.98);
          backdrop-filter: blur(10px);
          box-shadow: 0 2px 15px rgba(0, 0, 0, 0.08);
        }
      `}</style>
    </>
  );
}

export default Navbar;